module.exports = __webpack_public_path__ + "img/ug313.718aaab0.png";